import { createContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

const context = {
    messages: [],
    setMessages: () => {},
    upsertMessages: () => {}
}

export const MessageContext = createContext(context);

const MessageContextProvider = ({ children }) => {
    const [messages, setMessages] = useState([]);

    const upsertMessages = (messagesToUpsert) => {
        const newMessages = [...messages];
        for (const messageToUpsert of messagesToUpsert) {
            const index = newMessages.findIndex(message => message.id === messageToUpsert.id);
            if (index !== -1) {
                newMessages[index] = messageToUpsert;
            } else {
                newMessages.push(messageToUpsert);
            }
        }
        setMessages(newMessages);
    }

    const providerValue = useMemo(() => (
        { messages, setMessages, upsertMessages }
    ), [messages, setMessages, upsertMessages]);

    return (
        <MessageContext.Provider value={providerValue}>
            {children}
        </MessageContext.Provider>
    )
}

MessageContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default MessageContextProvider;
